<template>
    <div>
        <v-switch
            v-model="picRotation"
            label="Bilder Rotation"
            inset
          ></v-switch>
    </div>
</template>
<script>
export default {
    computed: {
        picRotation: {
            get() { return this.$store.state.picRotation },
            set(value) { this.$store.commit('updatePicRotation', value) } },
    }
}

</script>
<style lang="">
    
</style>